import React from 'react'
import { translatable } from 'react-instantsearch-core'
import { createClassNames } from '../../../helpers'
import InputCheckbox from '@bit/atd.web.forms.input-checkbox'
import List from '../List'
import FilterResults from '../FilterResults'

const cx = createClassNames('RefinementList')

type PropItem = {
  label: string
  value: boolean
  count: boolean
  isRefined: boolean
}

type PropsType = {
  translate: (key: string, ...params: any[]) => string
  refine: (item: boolean | never[]) => void
  searchForItems: () => void
  searchable: boolean
  createURL: () => void
  items: PropItem[]
  isFromSearch: boolean
  canRefine: boolean
  showMore: boolean
  limit: number
  showMoreLimit: number
  transformItems?: () => void
  className?: string
}

const RefinementList = (props: PropsType) => {
  const {
    translate,
    items,
    showMore,
    limit,
    showMoreLimit,
    isFromSearch,
    searchForItems,
    searchable,
    canRefine,
    className,
    refine,
  } = props

  const state = {
    query: '',
  }

  /**
   *
   * @param item
   * @param resetQuery
   */
  const selectItem = (item: PropItem, resetQuery: () => void) => {
    resetQuery()

    // @todo unsure of use cse for this reset condition
    // refine(item.isRefined ? [] : item.value)

    refine(item.value)
  }

  /**
   *
   * @param item
   * @param resetQuery
   */
  const renderItem = (item: PropItem, resetQuery: () => void) => {
    return (
      <label className={cx('label')}>
        <InputCheckbox
          name={item.label}
          label={item.label}
          labelPlacement="right"
          size="small"
          checked={item.isRefined}
          onChange={() => selectItem(item, resetQuery)}
        />
      </label>
    )
  }

  return (
    <FilterResults>
      {items.length ? (
        <List
          renderItem={renderItem}
          selectItem={selectItem}
          cx={cx}
          translate={translate}
          items={items}
          showMore={showMore}
          limit={limit}
          showMoreLimit={showMoreLimit}
          isFromSearch={isFromSearch}
          searchForItems={searchForItems}
          searchable={searchable}
          canRefine={canRefine}
          className={className}
          //  @ts-ignore
          query={state.query}
        />
      ) : (
        <div>no options available</div>
      )}
    </FilterResults>
  )
}

RefinementList.defaultProps = {
  className: '',
}

export default translatable({
  showMore: (extended) => (extended ? 'Show less' : 'Show more'),
  noResults: 'No results',
  submit: '',
  reset: '',
  resetTitle: 'Clear the search query.',
  submitTitle: 'Submit your search query.',
  placeholder: 'Search here…',
})(RefinementList)
